module.exports = __webpack_public_path__ + "832b992dee253b56192af763f2d85238.pdf";